export const DashIcon = ({ fill = "#13CEFF" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon/Ouline/Category">
      <g id="Category">
        <path
          id="Stroke 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0004 6.6738C21.0004 8.7024 19.3552 10.3476 17.3266 10.3476C15.298 10.3476 13.6537 8.7024 13.6537 6.6738C13.6537 4.6452 15.298 3 17.3266 3C19.3552 3 21.0004 4.6452 21.0004 6.6738Z"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3467 6.6738C10.3467 8.7024 8.7024 10.3476 6.6729 10.3476C4.6452 10.3476 3 8.7024 3 6.6738C3 4.6452 4.6452 3 6.6729 3C8.7024 3 10.3467 4.6452 10.3467 6.6738Z"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0004 17.2619C21.0004 19.2905 19.3552 20.9348 17.3266 20.9348C15.298 20.9348 13.6537 19.2905 13.6537 17.2619C13.6537 15.2333 15.298 13.5881 17.3266 13.5881C19.3552 13.5881 21.0004 15.2333 21.0004 17.2619Z"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 7"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.3467 17.2619C10.3467 19.2905 8.7024 20.9348 6.6729 20.9348C4.6452 20.9348 3 19.2905 3 17.2619C3 15.2333 4.6452 13.5881 6.6729 13.5881C8.7024 13.5881 10.3467 15.2333 10.3467 17.2619Z"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export const ResiIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.07874 16.1354H14.8937"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.40002 13.713C2.40002 8.082 3.01402 8.475 6.31902 5.41C7.76502 4.246 10.015 2 11.958 2C13.9 2 16.195 4.235 17.654 5.41C20.959 8.475 21.572 8.082 21.572 13.713C21.572 22 19.613 22 11.986 22C4.35903 22 2.40002 22 2.40002 13.713Z"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProxyIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 10.0001C0.75 16.9371 3.063 19.2501 10 19.2501C16.937 19.2501 19.25 16.9371 19.25 10.0001C19.25 3.06311 16.937 0.750107 10 0.750107C3.063 0.750107 0.75 3.06311 0.75 10.0001Z"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.69781 13.3023L8.27181 8.2723L13.3018 6.6983L11.7278 11.7273L6.69781 13.3023Z"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShopIcon = ({ fill = "#13CEFF" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3638 6.8699C16.3638 4.4839 14.4298 2.5499 12.0438 2.5499C9.65777 2.5389 7.71577 4.4649 7.70477 6.8509V6.8699"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9727 11.3738H14.9267"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.14159 11.3738H9.09559"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0342 21.4895C5.52619 21.4895 4.77719 19.4395 3.31619 14.0225C1.85019 8.5885 4.79119 6.5555 12.0342 6.5555C19.2772 6.5555 22.2182 8.5885 20.7522 14.0225C19.2912 19.4395 18.5422 21.4895 12.0342 21.4895Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StatementIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5958 15.6964H8.37579"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5958 11.9366H8.37579"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.131 8.1773H8.37598"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.60999 12.0001C3.60999 18.9371 5.70798 21.2501 12.001 21.2501C18.295 21.2501 20.392 18.9371 20.392 12.0001C20.392 5.0631 18.295 2.7501 12.001 2.7501C5.70798 2.7501 3.60999 5.0631 3.60999 12.0001Z"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingIcon = () => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 8.5C11.3809 8.5 12.5 9.61912 12.5 11C12.5 12.3809 11.3809 13.5 10 13.5C8.61912 13.5 7.5 12.3809 7.5 11C7.5 9.61912 8.61912 8.5 10 8.5Z"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.168 6.25025V6.25025C17.4845 5.05799 15.9712 4.65004 14.7885 5.33852C13.7598 5.93613 12.4741 5.18838 12.4741 3.99218C12.4741 2.61619 11.3659 1.5 9.99976 1.5V1.5C8.63365 1.5 7.52546 2.61619 7.52546 3.99218C7.52546 5.18838 6.23977 5.93613 5.21199 5.33852C4.02829 4.65004 2.51507 5.05799 1.83153 6.25025C1.14896 7.4425 1.55399 8.96665 2.73769 9.65415C3.76546 10.2527 3.76546 11.7473 2.73769 12.3459C1.55399 13.0343 1.14896 14.5585 1.83153 15.7498C2.51507 16.942 4.02829 17.35 5.21101 16.6625H5.21199C6.23977 16.0639 7.52546 16.8116 7.52546 18.0078V18.0078C7.52546 19.3838 8.63365 20.5 9.99976 20.5V20.5C11.3659 20.5 12.4741 19.3838 12.4741 18.0078V18.0078C12.4741 16.8116 13.7598 16.0639 14.7885 16.6625C15.9712 17.35 17.4845 16.942 18.168 15.7498C18.8515 14.5585 18.4455 13.0343 17.2628 12.3459H17.2618C16.2341 11.7473 16.2341 10.2527 17.2628 9.65415C18.4455 8.96665 18.8515 7.4425 18.168 6.25025Z"
      stroke="#13CEFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DiscordIcon = () => (
  <svg
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.54 0H2.46012C1.10406 0 0 1.10236 0 2.4684V18.6686C0 20.0347 1.10398 21.137 2.46004 21.137H16.068L15.432 18.9203L16.968 20.3462L18.42 21.6882L21 23.9649V2.4684C21 1.10236 19.896 0 18.54 0ZM13.908 15.6491C13.908 15.6491 13.476 15.1338 13.116 14.6785C14.688 14.2351 15.288 13.2526 15.288 13.2526C14.796 13.5761 14.328 13.8038 13.908 13.9595C13.308 14.2112 12.732 14.3789 12.168 14.4748C11.016 14.6905 9.95999 14.6306 9.06002 14.4628C8.37597 14.3309 7.78796 14.1393 7.29602 13.9476C7.01999 13.8397 6.72 13.7079 6.41993 13.5402C6.384 13.5162 6.34799 13.5042 6.31198 13.4802C6.28802 13.4683 6.27596 13.4563 6.26399 13.4443C6.048 13.3245 5.92799 13.2406 5.92799 13.2406C5.92799 13.2406 6.50401 14.1992 8.02799 14.6545C7.66804 15.1099 7.224 15.6491 7.224 15.6491C4.57193 15.5652 3.56401 13.8278 3.56401 13.8278C3.56401 9.96942 5.292 6.84197 5.292 6.84197C7.01999 5.54785 8.66398 5.58381 8.66398 5.58381L8.78399 5.72764C6.62402 6.35058 5.628 7.29731 5.628 7.29731C5.628 7.29731 5.89198 7.15356 6.33593 6.94984C7.61996 6.38662 8.64002 6.23091 9.06002 6.19495C9.13196 6.18291 9.19201 6.17095 9.26404 6.17095C10.0682 6.06634 10.882 6.05831 11.6881 6.14703C12.828 6.27883 14.052 6.61433 15.3 7.29731C15.3 7.29731 14.352 6.39866 12.312 5.77556L12.48 5.58389C12.48 5.58389 14.124 5.54785 15.852 6.84205C15.852 6.84205 17.58 9.96942 17.58 13.8278C17.58 13.8278 16.56 15.5652 13.908 15.6491V15.6491ZM8.32798 10.0533C7.644 10.0533 7.10407 10.6524 7.10407 11.3833C7.10407 12.1143 7.65598 12.7134 8.32798 12.7134C9.01204 12.7134 9.55196 12.1143 9.55196 11.3833C9.56402 10.6524 9.01204 10.0533 8.32806 10.0533H8.32798ZM12.708 10.0533C12.024 10.0533 11.484 10.6524 11.484 11.3833C11.484 12.1143 12.036 12.7134 12.708 12.7134C13.392 12.7134 13.9319 12.1143 13.9319 11.3833C13.9319 10.6524 13.392 10.0533 12.708 10.0533Z"
      fill="#486BE7"
    />
  </svg>
);

export const DownArrow = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 6L8 9.5L11 6"
      stroke="#93B0C8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Trash = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10"
      r="9.75"
      fill="white"
      stroke="#DEE1E3"
      strokeWidth="0.5"
    />
    <path
      d="M13.1847 8.95352C13.1847 8.98186 12.9626 11.7905 12.8358 12.9725C12.7564 13.6979 12.2887 14.1379 11.5873 14.1504C11.0483 14.1625 10.5207 14.1667 10.0016 14.1667C9.4505 14.1667 8.91154 14.1625 8.38839 14.1504C7.71044 14.1342 7.2424 13.6854 7.16703 12.9725C7.03654 11.7863 6.81853 8.98186 6.81448 8.95352C6.81043 8.86811 6.83798 8.78686 6.8939 8.72103C6.94901 8.6602 7.02844 8.62354 7.11192 8.62354H12.8913C12.9744 8.62354 13.0498 8.6602 13.1093 8.72103C13.1648 8.78686 13.1928 8.86811 13.1847 8.95352Z"
      fill="#8C93A2"
    />
    <path
      d="M13.75 7.49037C13.75 7.31912 13.6151 7.18496 13.453 7.18496H12.2381C11.9909 7.18496 11.7761 7.00914 11.721 6.76123L11.6529 6.45749C11.5577 6.09042 11.2291 5.83334 10.8603 5.83334H9.1401C8.76729 5.83334 8.44189 6.09042 8.34301 6.47749L8.27939 6.76164C8.22388 7.00914 8.0091 7.18496 7.76232 7.18496H6.54744C6.38494 7.18496 6.25 7.31912 6.25 7.49037V7.6487C6.25 7.81577 6.38494 7.9541 6.54744 7.9541H13.453C13.6151 7.9541 13.75 7.81577 13.75 7.6487V7.49037Z"
      fill="#8C93A2"
    />
  </svg>
);

export const MenuIcon = () => (
  <svg
    width="13"
    height="3"
    viewBox="0 0 13 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.5" cy="1.5" r="1.5" fill="#A0A5BA" />
    <circle cx="6.5" cy="1.5" r="1.5" fill="#A0A5BA" />
    <circle cx="11.5" cy="1.5" r="1.5" fill="#A0A5BA" />
  </svg>
);

export const ArrowLeft = () => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.02123 0.495471L0.509526 4.82387C-0.169842 5.47563 -0.169842 6.52849 0.509526 7.18025L5.02123 11.5086C6.11867 12.5615 8 11.8095 8 10.3221L8 1.66531C8 0.177944 6.11867 -0.557382 5.02123 0.495471Z"
      fill="#93B0C8"
    />
  </svg>
);

export const ArrowRight = () => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.97877 11.5045L7.49047 7.17613C8.16984 6.52437 8.16984 5.47151 7.49047 4.81975L2.97877 0.49135C1.88133 -0.561503 -5.16208e-07 0.190536 -4.51193e-07 1.6779L-7.27929e-08 10.3347C-7.77818e-09 11.8221 1.88133 12.5574 2.97877 11.5045Z"
      fill="#93B0C8"
    />
  </svg>
);

export const Download = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M1.33325 5.27727V10.7226C1.33325 13.0819 2.85059 14.6666 5.10992 14.6666H10.8899C13.1493 14.6666 14.6666 13.0819 14.6666 10.7226V5.27727C14.6666 2.9186 13.1486 1.33327 10.8893 1.33327H5.10992C2.85059 1.33327 1.33325 2.9186 1.33325 5.27727Z"
      fill="#606E79"
    />
    <path
      d="M5.14705 8.57026L7.64572 11.0803C7.83372 11.2689 8.16638 11.2689 8.35505 11.0803L10.8537 8.57026C11.0484 8.37426 11.0477 8.0576 10.8517 7.86293C10.6557 7.66826 10.3397 7.66826 10.1444 7.86426L8.49972 9.5156V5.27893C8.49972 5.00226 8.27572 4.77893 7.99972 4.77893C7.72372 4.77893 7.49972 5.00226 7.49972 5.27893V9.5156L5.85572 7.86426C5.75772 7.76626 5.62972 7.7176 5.50105 7.7176C5.37372 7.7176 5.24572 7.76626 5.14838 7.86293C4.95305 8.0576 4.95238 8.37426 5.14705 8.57026Z"
      fill="#606E79"
    />
  </svg>
);

export const RedTrash = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5247 3.49531C13.7841 3.49531 14 3.71064 14 3.98463V4.23797C14 4.5053 13.7841 4.72729 13.5247 4.72729H2.4759C2.21591 4.72729 2 4.5053 2 4.23797V3.98463C2 3.71064 2.21591 3.49531 2.4759 3.49531H4.41971C4.81457 3.49531 5.1582 3.21464 5.24703 2.81865L5.34882 2.36398C5.50702 1.74466 6.02766 1.33333 6.62351 1.33333H9.37649C9.96585 1.33333 10.4923 1.74466 10.6447 2.33132L10.7536 2.81798C10.8418 3.21464 11.1854 3.49531 11.5809 3.49531H13.5247ZM12.5372 12.756C12.7402 10.8647 13.0955 6.37141 13.0955 6.32608C13.1084 6.18875 13.0637 6.05875 12.9749 5.95408C12.8796 5.85608 12.759 5.79808 12.626 5.79808H3.37901C3.24545 5.79808 3.11837 5.85608 3.03019 5.95408C2.94072 6.05875 2.89663 6.18875 2.90311 6.32608C2.9043 6.33441 2.91705 6.49268 2.93837 6.7573C3.03306 7.9328 3.29678 11.2068 3.46719 12.756C3.58779 13.8973 4.33665 14.6147 5.42137 14.6407C6.25842 14.66 7.12075 14.6667 8.00253 14.6667C8.83309 14.6667 9.67662 14.66 10.5396 14.6407C11.6619 14.6213 12.4101 13.9167 12.5372 12.756Z"
      fill="#FF503D"
    />
  </svg>
);

export const CheckSvg = ({ checked }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 9C0 15.7495 2.25049 18 9 18C15.7495 18 18 15.7495 18 9C18 2.25049 15.7495 0 9 0C2.25049 0 0 2.25049 0 9Z"
      fill={checked ? "#19BEBE" : "#DEE1E3"}
    />
    <path
      d="M6 9.30886L8.30984 11.6177L12.9276 7"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BackSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25 12.2743L19.25 12.2743"
      stroke="#606E79"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2998 18.2987L4.2498 12.2747L10.2998 6.24969"
      stroke="#606E79"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckedBlueSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="#165CEE" />
    <path
      d="M9.16511 13.8848C8.91622 13.8848 8.66733 13.7903 8.47733 13.6003L5.84066 10.9637C5.46066 10.5837 5.46066 9.9681 5.84066 9.58921C6.22066 9.20921 6.83511 9.2081 7.21511 9.5881L9.16511 11.5381L13.7518 6.95144C14.1318 6.57144 14.7462 6.57144 15.1262 6.95144C15.5062 7.33144 15.5062 7.94699 15.1262 8.32699L9.85289 13.6003C9.66289 13.7903 9.414 13.8848 9.16511 13.8848"
      fill="white"
    />
  </svg>
);

export const UncheckedSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10"
      r="9.25"
      fill="white"
      stroke="#BFC4CE"
      strokeWidth="1.5"
    />
  </svg>
);

export const FamilySvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.772 5.48856C10.772 7.05501 9.52326 8.31106 7.96586 8.31106C6.40845 8.31106 5.15966 7.05501 5.15966 5.48856C5.15966 3.9215 6.40845 2.66666 7.96586 2.66666C9.52326 2.66666 10.772 3.9215 10.772 5.48856ZM7.96586 13.3333C5.6784 13.3333 3.72523 12.9707 3.72523 11.5201C3.72523 10.0689 5.66587 9.69307 7.96586 9.69307C10.2533 9.69307 12.2065 10.0557 12.2065 11.5069C12.2065 12.9575 10.2658 13.3333 7.96586 13.3333ZM11.9712 5.53947C11.9712 6.33801 11.7331 7.08191 11.3152 7.70033C11.2722 7.76397 11.3104 7.84983 11.3862 7.86304C11.4907 7.88105 11.5987 7.89126 11.7086 7.89426C12.804 7.92308 13.7871 7.214 14.0587 6.14648C14.461 4.56081 13.2797 3.13725 11.7754 3.13725C11.6119 3.13725 11.4555 3.15467 11.3033 3.18589C11.2824 3.19069 11.2603 3.2003 11.2483 3.21891C11.234 3.24172 11.2448 3.27234 11.2591 3.29216C11.711 3.92919 11.9712 4.70611 11.9712 5.53947ZM13.7853 9.00837C14.5213 9.15307 15.0055 9.44847 15.206 9.87775C15.3756 10.2302 15.3756 10.6391 15.206 10.9909C14.8992 11.6568 13.9101 11.8705 13.5257 11.9257C13.4463 11.9377 13.3824 11.8687 13.3907 11.7888C13.5871 9.9438 12.025 9.06901 11.6208 8.86787C11.6035 8.85887 11.5999 8.84506 11.6017 8.83665C11.6029 8.83065 11.6101 8.82104 11.6232 8.81924C12.4977 8.80303 13.4379 8.92311 13.7853 9.00837ZM4.29124 7.8942C4.40108 7.8912 4.50853 7.88159 4.61359 7.86298C4.6894 7.84977 4.7276 7.76391 4.68462 7.70027C4.26677 7.08185 4.02859 6.33795 4.02859 5.53941C4.02859 4.70605 4.28886 3.92913 4.74074 3.2921C4.75506 3.27228 4.76521 3.24166 4.75148 3.21885C4.73954 3.20084 4.71686 3.19063 4.69656 3.18583C4.54375 3.15461 4.38735 3.13719 4.22379 3.13719C2.71951 3.13719 1.53818 4.56075 1.94111 6.14642C2.21272 7.21394 3.19587 7.92302 4.29124 7.8942ZM4.3978 8.83629C4.39959 8.8453 4.39601 8.85851 4.37929 8.86811C3.97457 9.06925 2.41239 9.94404 2.60878 11.7885C2.61714 11.8689 2.55386 11.9374 2.47447 11.926C2.09005 11.8707 1.10092 11.657 0.794099 10.9911C0.623972 10.6387 0.623972 10.2304 0.794099 9.878C0.994669 9.44871 1.47819 9.15331 2.21421 9.00801C2.56222 8.92335 3.5018 8.80327 4.3769 8.81948C4.39004 8.82128 4.3966 8.83089 4.3978 8.83629Z"
      fill="white"
    />
  </svg>
);

export const AddSvg = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.05384 0.833374H6.94134C8.35801 0.833374 9.16634 1.63337 9.16634 3.05421V6.94587C9.16634 8.35837 8.36218 9.16671 6.94551 9.16671H3.05384C1.63301 9.16671 0.833008 8.35837 0.833008 6.94587V3.05421C0.833008 1.63337 1.63301 0.833374 3.05384 0.833374ZM5.34134 5.34587H6.52467C6.71634 5.34171 6.87051 5.18754 6.87051 4.99587C6.87051 4.80421 6.71634 4.65004 6.52467 4.65004H5.34134V3.47504C5.34134 3.28337 5.18717 3.12921 4.99551 3.12921C4.80384 3.12921 4.64967 3.28337 4.64967 3.47504V4.65004H3.47051C3.37884 4.65004 3.29134 4.68754 3.22467 4.75004C3.16217 4.81671 3.12467 4.90379 3.12467 4.99587C3.12467 5.18754 3.27884 5.34171 3.47051 5.34587H4.64967V6.52504C4.64967 6.71671 4.80384 6.87087 4.99551 6.87087C5.18717 6.87087 5.34134 6.71671 5.34134 6.52504V5.34587Z"
      fill="#1B61EE"
    />
  </svg>
);

export const CloseSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        opacity="0.4"
        d="M9.53199 1.16655H4.47449C2.49699 1.16655 1.16699 2.55488 1.16699 4.61988V9.38572C1.16699 11.4449 2.49699 12.8332 4.47449 12.8332H9.53199C11.5095 12.8332 12.8337 11.4449 12.8337 9.38572V4.61988C12.8337 2.55488 11.5095 1.16655 9.53199 1.16655Z"
        fill="white"
      />
      <path
        d="M8.75984 8.03268L7.72209 6.99551L8.75926 5.95834C8.95876 5.75943 8.95876 5.43568 8.75926 5.23676C8.55976 5.03609 8.23717 5.03668 8.03767 5.23618L6.99992 6.27334L5.96217 5.23501C5.76267 5.03551 5.43951 5.03668 5.24001 5.23501C5.04109 5.43451 5.04109 5.75826 5.24001 5.95718L6.27834 6.99551L5.24234 8.03093C5.04284 8.23043 5.04284 8.55418 5.24234 8.75251C5.34209 8.85285 5.47217 8.90243 5.60284 8.90243C5.73409 8.90243 5.86417 8.85285 5.96392 8.7531L6.99992 7.7171L8.03826 8.75485C8.13801 8.8546 8.26809 8.90418 8.39876 8.90418C8.52942 8.90418 8.66009 8.85401 8.75984 8.75485C8.95934 8.55535 8.95934 8.23218 8.75984 8.03268Z"
        fill="white"
      />
    </g>
  </svg>
);

export const DataUsageSvg = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4C3.10457 4 4 4.89543 4 6V16C4 17.1046 3.10457 18 2 18C0.895431 18 0 17.1046 0 16V6C0 4.89543 0.895431 4 2 4Z"
      fill="#165CEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C9.10457 0 10 0.89543 10 2V16C10 17.1046 9.10457 18 8 18C6.89543 18 6 17.1046 6 16V2C6 0.89543 6.89543 0 8 0Z"
      fill="#165CEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 10C15.1046 10 16 10.8954 16 12V16C16 17.1046 15.1046 18 14 18C12.8954 18 12 17.1046 12 16V12C12 10.8954 12.8954 10 14 10Z"
      fill="#165CEE"
    />
  </svg>
);

export const SignOutIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5129 6.15792V5.38042C12.5129 3.68459 11.1379 2.30959 9.44207 2.30959H5.37957C3.68457 2.30959 2.30957 3.68459 2.30957 5.38042V14.6554C2.30957 16.3513 3.68457 17.7263 5.37957 17.7263H9.4504C11.1412 17.7263 12.5129 16.3554 12.5129 14.6646V13.8788"
      stroke="#606E79"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1738 10.0178H8.13965"
      stroke="#606E79"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.7344 7.58858L18.1744 10.0178L15.7344 12.4478"
      stroke="#606E79"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.5 13.0583V6.71416H15.5V13.1092C15.5 15.725 13.8535 17.3333 11.219 17.3333H4.77278C2.16301 17.3333 0.5 15.6917 0.5 13.0583ZM4.63282 11.0083C4.25412 11.0258 3.94127 10.725 3.92481 10.3425C3.92481 9.95916 4.22119 9.6425 4.59989 9.625C4.97036 9.625 5.27497 9.9175 5.28321 10.2917C5.29967 10.6758 5.00329 10.9925 4.63282 11.0083ZM8.01647 11.0083C7.63776 11.0258 7.32492 10.725 7.30845 10.3425C7.30845 9.95916 7.60483 9.6425 7.98353 9.625C8.35401 9.625 8.65862 9.9175 8.66685 10.2917C8.68332 10.6758 8.38694 10.9925 8.01647 11.0083ZM11.3754 14.075C10.9967 14.0667 10.6921 13.75 10.6921 13.3667C10.6839 12.9833 10.9885 12.6675 11.3672 12.6592H11.3754C11.7623 12.6592 12.0752 12.9758 12.0752 13.3667C12.0752 13.7583 11.7623 14.075 11.3754 14.075ZM7.30845 13.3667C7.32492 13.75 7.63776 14.0508 8.01647 14.0333C8.38694 14.0175 8.68332 13.7008 8.66685 13.3175C8.65862 12.9425 8.35401 12.65 7.98353 12.65C7.60483 12.6675 7.30845 12.9833 7.30845 13.3667ZM3.91658 13.3667C3.93304 13.75 4.24588 14.0508 4.62459 14.0333C4.99506 14.0175 5.29144 13.7008 5.27497 13.3175C5.26674 12.9425 4.96213 12.65 4.59166 12.65C4.21295 12.6675 3.91658 12.9833 3.91658 13.3667ZM10.7003 10.3342C10.7003 9.95083 10.9967 9.6425 11.3754 9.63416C11.7459 9.63416 12.0423 9.93333 12.0587 10.3008C12.067 10.6842 11.7706 11.0008 11.4001 11.0083C11.0214 11.0167 10.7086 10.725 10.7003 10.3425V10.3342Z"
      fill="#1B61EE"
    />
    <path
      opacity="0.4"
      d="M0.502792 6.71408C0.513495 6.22492 0.554658 5.25408 0.632046 4.94158C1.02722 3.18408 2.36915 2.06742 4.28737 1.90825H11.7133C13.615 2.07575 14.9734 3.19992 15.3686 4.94158C15.4452 5.24575 15.4863 6.22408 15.497 6.71408H0.502792Z"
      fill="#1B61EE"
    />
    <path
      d="M4.92072 4.49166C5.28296 4.49166 5.55464 4.2175 5.55464 3.85V1.30916C5.55464 0.941664 5.28296 0.666664 4.92072 0.666664C4.55848 0.666664 4.2868 0.941664 4.2868 1.30916V3.85C4.2868 4.2175 4.55848 4.49166 4.92072 4.49166"
      fill="#1B61EE"
    />
    <path
      d="M11.0791 4.49166C11.4331 4.49166 11.713 4.2175 11.713 3.85V1.30916C11.713 0.941664 11.4331 0.666664 11.0791 0.666664C10.7169 0.666664 10.4452 0.941664 10.4452 1.30916V3.85C10.4452 4.2175 10.7169 4.49166 11.0791 4.49166"
      fill="#1B61EE"
    />
  </svg>
);
